import { render, staticRenderFns } from "./CreateHSCodeModal.vue?vue&type=template&id=be68ea66&scoped=true"
import script from "./CreateHSCodeModal.vue?vue&type=script&lang=js"
export * from "./CreateHSCodeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateHSCodeModal.vue?vue&type=style&index=0&id=be68ea66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be68ea66",
  null
  
)

export default component.exports